import { z } from 'zod';
import { addressSchema } from './address';
import { paymentSchema } from './payment';
import { dateTimeSchema, uidSchema, variationSelectionSchema } from './shared';

export const offerSchema = z
  .object({
    account_id: z.string(),
    address: addressSchema,
    attribution: z
      .object({
        data_source: z.string().optional(),
        page: z.string().optional(),
        section: z.string().optional(),
      })
      .default({}),
    buyer_id: uidSchema,
    chat_id: z.string().optional(), // optional for auctions
    created: dateTimeSchema,
    current_price: z.number().gt(0).default(1), // product's current price
    customer_id: z.string().optional(),
    failed: z.boolean().optional(),
    from_web: z.boolean().default(true),
    id: z.string(),
    is_auction: z.boolean().default(false),
    is_exclusive: z.boolean().default(false),
    is_counter: z.boolean().optional().default(false),
    message: z.string().default(''),
    payment: paymentSchema,
    price: z.number().gt(0), // offer price
    product_id: z.string(),
    rate_id: z.string().optional(),
    seller_id: uidSchema,
    shipping_cost: z.number().gte(0).default(0),
    state: z.number().min(0).max(3).default(0), // pending:0, accepted:1, declined:2, expired:3
    tax: z.number().gte(0).default(0),
    time_remaining: dateTimeSchema.optional(), // created + one day
    total: z.number().gt(0).lt(1_000_000),
    uid: uidSchema.optional(), // offer creator - added 7/9/24
    uids: z.array(uidSchema).length(2),
    variation: variationSelectionSchema.optional(),
  })
  .transform((data) => {
    const oneDay = 60 * 60 * 24 * 1000;
    data.time_remaining = data.created + oneDay;
    return data;
  });
export interface OfferDocument extends z.output<typeof offerSchema> {}
//   const discounted = this.current_price * 0.85;
// this.price = Math.round(discounted * 100) / 100;
